import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2af200b3"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales/global.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftsno%2Fpafm%2Fonline%2Fwebapp%2Fsrc%2Fcomponents%2Ftime-range%2Findex.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports